export const TP_SUPORTE_FALE_CONOSCO = "FC";

export interface Suporte {
  cdSeqSuporte: number;
  noSuporte: string;
  dsSuporte: string;
  dsLinkSuporte: string | null;
  dsImgSuporte: string;
  tpSuporte: string;
  nuOrdenSuporte: number;
  stAtivo: boolean;
  dtCriacao: string;
  noUsuarioCriacao: string;
  dtAtualizacao: string | null;
  noUsuarioAtualizacao: string | null;
}

export interface SuportePaginado {
  items: Suporte[];
  page: number;
  pageSize: number;
  totalItems: number;
}

export function isValidPortalUrl(value?: string | null): boolean {
  if (!value) {
    return false;
  }

  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}
